// extracted by mini-css-extract-plugin
export var activityContainer = "_jj-0";
export var typingIndicatorContainer = "_jj-1";
export var typingIndicatorDot = "_jj-2";
export var wave = "_jj-3";